import { render, staticRenderFns } from "./DonorConsentAttachmentsPrint.vue?vue&type=template&id=1476fed8"
import script from "./DonorConsentAttachmentsPrint.vue?vue&type=script&lang=js"
export * from "./DonorConsentAttachmentsPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports